import * as ko from "knockout";
import {SPINNER} from "../../../constants";
import {global} from "../../../appContext";
import {AbstractDialogOperation, IParams} from "./AbstractDialogOperation";
import {TServiceName} from "../../../constants/ApiServices";
import {FormValidator} from "../../password/v2/FormValidator";
import PromiseRequest from "../../../req/PromiseRequest";
import reset_passwordHtml from './reset.password.html?raw';

export let template: string = reset_passwordHtml;

export class viewModel extends AbstractDialogOperation {

    protected serviceName: TServiceName = "resetpassword";

    private readonly passwordpolicy = (global.login.selectedOrganization() ?? global.login.getHomeOrg()!).passwordpolicy
    private readonly mode: TPasswordPageMode = 'admin'
    private readonly observableInputs: IObservableInputs = {
        old: ko.observable(''),
        new: ko.observable(''),
        repeat: ko.observable(''),
        toggle_old: ko.observable(true),
        toggle_new: ko.observable(true),
        toggle_repeat: ko.observable(true),
    }
    private readonly formValidator = new FormValidator({
        observableInputs: this.observableInputs,
        passwordPolicy: this.passwordpolicy,
        mode: this.mode,
    })
    private readonly isGenerating: KnockoutObservable<boolean> = ko.observable(false)
    private readonly req_generatepassword: PromiseRequest = new PromiseRequest('generatepassword')
    private readonly isValid = this.formValidator.isFormValid

    constructor(protected override params: IParams) {
        super(params);
    }

    protected getProcessItemSuccessMessage(): string {
        return `((updating|td)) [${this.submitSuccess.length + this.submitError.length}/${this.numTotal}] ${SPINNER}`;
    }

    protected successMessage(): string {
        const n = this.submitSuccess.length;
        return `password.reset success|name:${this.getNumObjectsLabel(n)}`
    }

    protected errorMessage(): string {
        const n = this.submitError.length;
        return `password.reset failure|name:${this.getNumObjectsLabel(n)}`
    }

    protected override getRequestParams(id: number) {
        return {
            id: id,
            newpassword: this.observableInputs.new(),
        };
    }

    private onSuggestPasswordClick() {
        this.isGenerating(true)
        this.req_generatepassword.request({nr: 1})
            .then((data: [string]) => {
                this.observableInputs.new(data[0])
                this.observableInputs.repeat(data[0])
                this.observableInputs.toggle_new(false)
                this.observableInputs.toggle_repeat(false)
            })
            .finally(() => this.isGenerating(false))
    }

    override dispose() {
        this.req_generatepassword.abort()
        super.dispose()
    }

}
